const ja = {
  nav: {
    about: "About",
    services: "サービス",
    partners: "取引先",
    contact: "お問い合わせ",
    contactBtn: "お問い合わせ",
  },
  hero: {
    tagline: "JAPAN MARKET ENTRY SPECIALIST",
    title1: "日本市場への扉を、",
    title2: "共に開く。",
    subtitle: "We open the door to Japan's market, together.",
    description: "海外ブランドの可能性を最大化する、日本屈指の総代理店パートナー。",
    descriptionEn: "Maximizing the potential of overseas brands — Japan's premier general agency partner.",
    cta: "お問い合わせはこちら",
    ctaEn: "Contact Us",
    scroll: "Scroll",
  },
  about: {
    label: "WHO WE ARE",
    labelJa: "私たちについて",
    title: "Our Mission",
    titleEn: "Our Mission",
    quote: "日本市場の扉を、共に開く。",
    p1: "私たちは、海外の優れたブランドと日本市場を繋ぐ専門家集団です。単なる輸入代理店ではなく、ブランドの価値を守りながら日本市場に根付かせるための戦略的パートナーです。",
    p2: "海外メーカーが日本市場で直面する課題——言語の壁、法規制の複雑さ、流通ネットワークの構築——これらすべてを、私たちが一手に引き受けます。あなたのブランドが日本で輝くために、全力でサポートします。",
    p3: "私たちは大企業ではありません。だからこそ、一社一社にしっかり向き合い、スピード感と柔軟性を持ってサポートできます。中小企業ならではの小回りの良さを活かし、海外メーカー様の日本市場展開を丁寧かつ実践的に支援します。",
    name: "木佐 誠宏",
    title2: "事業オーナー",
    more: "会社概要を見る",
    moreEn: "Learn More About Us",
    stat1: "20+",
    stat1Label: "対応国数",
    stat2: "100+",
    stat2Label: "取引社数",
    stat3: "15年",
    stat3Label: "実績年数",
    stat4: "98%",
    stat4Label: "継続率",
  },
  services: {
    label: "OUR SERVICES",
    labelJa: "サービス内容",
    title: "日本市場進出の全工程を、",
    title2: "ワンストップで。",
    titleEn: "End-to-end support for your Japan market entry.",
    s1Title: "クラウドファンディング事業",
    s1TitleEn: "Crowdfunding Business",
    s2Title: "EC事業",
    s2TitleEn: "E-Commerce Business",
    s3Title: "SNSマーケティング・広告運用",
    s3TitleEn: "SNS Marketing & Advertising",
    s4Title: "法規制・認証サポート",
    s4TitleEn: "Regulatory & Compliance",
    s5Title: "顧客サポート",
    s5TitleEn: "Customer Support",
    viewAll: "サービス詳細を見る",
    viewAllEn: "View All Services",
    backToHome: "ホームへ戻る",
    pageTitle: "私たちのサービス",
    pageTitle2: "詳細",
    pageDescription: "海外ブランドの日本市場進出を、戦略策定から実行までトータルサポート。20年以上の実績と専門知識で、あなたのビジネスを成功に導きます。",
    detail: {
      s1: {
        title: "クラウドファンディング事業",
        titleEn: "Crowdfunding Business",
        desc: "Makuake・Campfireなど国内主要クラウドファンディングプラットフォームを活用し、海外製品の日本市場デビューを成功に導きます。プロジェクト設計から運用・PR支援まで一貫してサポートします。",
        item1: "Makuake・Campfire等への出品戦略立案とプロジェクト設計",
        item2: "日本語コピーライティングとビジュアルコンテンツ制作",
        item3: "クラウドファンディング期間中のSNS・PR運用",
        item4: "支援者対応・リターン発送・アフターフォロー管理",
      },
      s2: {
        title: "EC事業",
        titleEn: "E-Commerce Business",
        desc: "Amazon・楽天・Yahoo!ショッピングなど国内主要ECプラットフォームへの出店から運営まで、海外ブランドのEC事業を包括的にサポートします。売上最大化に向けた戦略的な運用を実現します。",
        item1: "Amazon・楽天・Yahoo!ショッピングへの出店・ストア構築",
        item2: "商品ページ最適化（SEO・画像・コピーライティング）",
        item3: "在庫管理・物流・FBA活用による効率的な運営",
        item4: "広告運用（スポンサー広告・クーポン・セール戦略）",
      },
      s3: {
        title: "SNSマーケティング・広告運用",
        titleEn: "SNS Marketing & Advertising",
        desc: "Instagram・TikTok・X（旧Twitter）・YouTubeなど各SNSプラットフォームの特性を活かした戦略的なマーケティングと広告運用で、ブランド認知度の向上と購買促進を実現します。",
        item1: "各SNSプラットフォームに最適化したコンテンツ制作・投稿運用",
        item2: "インフルエンサーマーケティングとタイアップ企画",
        item3: "Meta広告・Google広告・TikTok広告の運用と最適化",
        item4: "データ分析に基づくPDCAサイクルと効果測定レポート",
      },
      s4: {
        title: "法規制・認証サポート",
        titleEn: "Regulatory & Compliance",
        desc: "日本特有の複雑な法規制や認証取得を専門チームがフルサポート。リスクを最小化し、スムーズな市場参入を実現します。",
        item1: "薬機法、食品衛生法、電波法などの法規制対応",
        item2: "JIS規格、SGマークなど各種認証取得支援",
        item3: "輸入手続きと税関対応サポート",
        item4: "製品ラベリングや表示義務のコンプライアンス確認",
      },
      s5: {
        title: "顧客サポート",
        titleEn: "Customer Support",
        desc: "日本語・英語に対応した専門サポートチームが、エンドユーザーからの問い合わせ対応、クレーム処理、アフターサービスまでをトータルにサポート。ブランドの信頼性を高め、顧客満足度の向上に貢献します。",
        item1: "日本語・英語対応のマルチリンガルカスタマーサポート",
        item2: "問い合わせ管理システムの構築と運用",
        item3: "クレーム対応・返品・交換プロセスの整備",
        item4: "顧客満足度調査とフィードバック分析",
      },
    },
    ctaTitle: "まずは無料相談から",
    ctaDescription: "あなたのブランドに最適な日本市場参入戦略を、専門コンサルタントが無料でご提案します。",
    ctaButton: "無料相談を申し込む",
  },
  achievements: {
    label: "ACHIEVEMENTS",
    labelJa: "事業実績",
    title: "事業実績",
    titleEn: "Our Business Achievements",
    ec: {
      title: "国内EC事業",
      titleEn: "Domestic E-commerce Business",
      description: "自社ECサイトの運営および大手ECプラットフォームへの出店を通じて、国内外の優れた商品を日本の消費者へ届けています。年間売上高は順調に成長を続け、安定した事業基盤を構築しています。",
    },
    web: {
      title: "WEBサイト構築・運用",
      titleEn: "Website Development & Operations",
      description: "企業向けに高品質なWEBサイトの企画・デザイン・開発・運用をワンストップで提供。レスポンシブ対応、SEO最適化、アクセシビリティ対応など、最新の技術とデザインでクライアントのデジタルプレゼンスを強化します。",
    },
  },
  partners: {
    label: "TRUSTED BY",
    labelJa: "取引実績",
    title: "世界20カ国、100社以上の",
    title2: "パートナー企業",
    titleEn: "Trusted by 100+ companies across 20+ countries.",
    note: "※一部取引先を掲載しています",
    regions: {
      northAmerica: "北米",
      europe: "欧州",
      asia: "アジア",
      oceania: "オセアニア",
      middleEast: "中東",
    },
  },
  contact: {
    label: "CONTACT US",
    labelJa: "お問い合わせ",
    title: "お問い合わせフォーム",
    titleEn: "Dedicated Inquiry Window for Overseas Manufacturers",
    englishAvailable: "英語対応可 / English Available",
    companyName: "会社名 / Company Name",
    yourName: "お名前 / Your Name",
    email: "メールアドレス / Email",
    phone: "電話番号 / Phone",
    country: "国・地域 / Country / Region",
    message: "お問い合わせ内容 / Message",
    messagePlaceholder: "ご相談内容をご記入ください。\nPlease describe your inquiry.",
    submit: "送信する / Submit",
    submitting: "送信中...",
    successTitle: "送信完了 / Message Sent",
    successMsg: "お問い合わせありがとうございます。担当者より2営業日以内にご連絡いたします。\nThank you for your inquiry. Our team will contact you within 2 business days.",
    directContact: "直接のご連絡はこちら",
    directContactEn: "Direct Contact",
    hours: "平日 9:00 - 18:00 (JST)",
    address: "〒100-0001 東京都千代田区千代田1-1-1\nグローバルビジネスタワー 15F",
    required: "必須",
    selectCountry: "国・地域を選択 / Select Country",
    charLimit: "500文字以内",
  },
  process: {
    label: "PROCESS / 取引の流れ",
    title: "お取引の流れ",
    subtitle: "初回のお問い合わせから販売開始まで、スピーディかつ丁寧にサポートいたします。",
    timelineLabel: "TIMELINE",
    timelineTitle: "標準的なステップ",
    faqLabel: "FAQ",
    faqTitle: "よくあるご質問",
    ctaTitle: "まずはお気軽にご相談ください",
    ctaSubtitle: "製品や取引条件についてのご質問など、お気軽にお問い合わせください。",
    ctaButton: "お問い合わせはこちら",
    navLink: "お取引の流れ",
    steps: {
      s1Title: "お問い合わせ",
      s1TitleEn: "Inquiry",
      s1Desc: "まずはお気軽にお問い合わせください。製品情報や販売戦略について、お話をお聞かせください。",
      s2Title: "市場分析・ご提案",
      s2TitleEn: "Analysis & Proposal",
      s2Desc: "日本市場での可能性を分析し、最適な販売戦略をご提案します。競合調査や価格帯分析も実施。",
      s3Title: "契約・販売開始",
      s3TitleEn: "Contract & Launch",
      s3Desc: "契約締結後、即座に販売準備を開始。クラウドファンディングやECモールへの出店をスピーディに進行。",
      s4Title: "運営・サポート",
      s4TitleEn: "Operation & Support",
      s4Desc: "販売開始後も継続的なサポート。在庫管理、カスタマーサポート、マーケティング施策の実行まで一貫対応。",
    },
    timeline: {
      t1: "お問い合わせ・初回打ち合わせ",
      t2: "市場分析・販売戦略策定",
      t3: "ご提案・契約締結",
      t4: "販売準備（ページ作成・在庫準備）",
      t5: "販売開始・運営サポート",
    },
    faq: {
      q1: "契約期間はどのくらいですか？",
      a1: "プロジェクトの規模や内容に応じて柔軟に対応いたします。クラウドファンディングのみの短期契約も可能です。",
      q2: "どのような製品を取り扱っていますか？",
      a2: "家電製品、ガジェット、ライフスタイルグッズ、アパレルなど幅広く取り扱っております。まずはお気軽にご相談ください。",
      q3: "在庫はどのように管理されますか？",
      a3: "日本国内の倉庫で在庫を保管・管理し、注文に応じて配送を行います。在庫状況はリアルタイムで確認可能です。",
      q4: "販売開始までどのくらいかかりますか？",
      a4: "契約締結から約2ヶ月程度で販売開始が可能です。クラウドファンディングの場合は準備期間が短縮できる場合があります。",
    },
  },
  strengths: {
    s1: "年商3000万円以上の販売実績",
    s2: "3年以上の国内EC事業の経験",
    s3: "Amazon・楽天・Yahoo!等でのEC販売経験",
    s4: "大企業には出来ないスピーディな意思決定",
    s5: "豊富なWEBサイト構築、広告収入実績",
  },
  footer: {
    description: "海外ブランドの可能性を最大化する、日本唯一の総代理店パートナー。20年以上の実績と100社以上の取引実績で、あなたのブランドを日本市場へ。",
    quickLinks: "QUICK LINKS",
    office: "OFFICE",
    legal: "LEGAL",
    privacy: "プライバシーポリシー",
    terms: "利用規約",
    tokushoho: "特定商取引法に基づく表記",
    copyright: "© 2026 SHOP-MK. All Rights Reserved.",
  },
  legal: {
    backHome: "ホームへ戻る",
    lastUpdated: "最終更新日",
  },
  aboutPage: {
    title: "会社概要",
    heroSub: "海外ブランドと日本市場を繋ぐ、戦略的パートナーとして。",
    missionLabel: "OUR MISSION",
    missionTitle: "世界の革新を、日本へ届ける。",
    missionText1: "「事業を大きくしたい。でも、新しい市場に手を広げる余裕はない。」",
    missionText2: "私たちが、日本市場をあなたのビジネスに届けます。",
    missionText3: "私たちは、あなたのブランドの日本総代理店であり、パートナーです。販売、マーケティング、物流、顧客対応まで、すべてお任せください。",
    missionText4: "まずクラウドファンディングで市場の反応を確かめ、手応えを得てからECモールへ本格展開。",
    missionText5: "あなたはプロダクトに集中するだけ。日本という新しい市場が、ビジネスに加わります。",
    missionCta: "あなたのブランドの次のステージを、一緒につくりましょう。",
    bridgeTitle: "世界と日本を繋ぐ架け橋",
    bridgeText1: "私たちは、ブランド代理店事業・EC運営事業・広告運営事業を通じて、海外メーカーの日本市場展開をトータルサポートする総合商社です。",
    bridgeText2: "「GlobalBridge」という社名には、世界中のパートナーと共に成長していきたいという想いが込められています。",
    bridgeText3: "アメリカ製品の輸入販売で培った経験とノウハウを活かし、海外メーカー様の日本市場参入を全面的にサポートいたします。",
    strengthsLabel: "OUR STRENGTHS",
    strengthsTitle: "私たちの強み",
    strengthSubtitle: "確かな実績と経験",
    companyInfoTitle: "事業概要",
    info: {
      companyName: "事業所名",
      companyNameValue: "SHOP-MK",
      established: "設立",
      establishedValue: "2025年1月",
      representative: "代表者名",
      representativeValue: "木佐 誠宏",
      repProfile: "代表者紹介",
      repText1: "大学卒業後、国内企業のシステムエンジニアとして14年間勤務。　　開発・構築経験を経て20個以上のPJマネージャーを担当。",
      repText2: "サイドビジネスとして、ブログサイトの運営を３年間、ライター業務、動画編集者としても収益化に成功。",
      repText3: "その後Amazon物販にも取り組み、主に中古品の販売事業で一定の成果が出たので独立。個人で年商約3,000万円を達成する。",
      repText4: "現在は、海外メーカー総代理として各国のメーカーと商談を進めている。",
      revenue: "年商",
      revenueValue: "3000万円（推定）",
    },
    partnersTitle: "取引先企業一覧",
    partners: {
      list1: "BASE株式会社",
      list2: "PayPal Holdings Inc.",
      list3: "PayPay銀行株式会社",
      list4: "Shopify Inc.",
      list5: "アマゾン ジャパン合同会社",
      list6: "グーグル合同会社",
      list7: "テレコムクレジット株式会社",
      list8: "ヤフー株式会社",
      list9: "ヤマト運輸株式会社",
      list10: "楽天グループ株式会社",
      list11: "株式会社千葉興業銀行",
      list12: "株式会社CAMPFIRE",
      list13: "株式会社マクアケ",
      list14: "株式会社メルカリ",
      list15: "株式会社ワンモア",
      list16: "株式会社千葉銀行",
      list17: "佐川急便株式会社",
      list18: "住信SBIネット銀行株式会社",
      list19: "東京ベイ信用金庫",
      list20: "日本郵政株式会社",
      list21: "流山商工会議所",
    },
    ctaTitle: "まずはお問い合わせください",
    ctaText: "パートナーシップや取り扱い製品についてのご質問など、お気軽にお問い合わせください。",
    ctaButton: "お問い合わせはこちら",
  },
};

export default ja;
